import { loadingController } from "@ionic/vue";
import i18n from "@/plugins/vue-i18n";

let loading: HTMLIonLoadingElement;
let isInit = false;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const t = i18n.global.t

export function useLoader() {
    const createLoadingController = async (message?: string): Promise<void> => {
        console.log('creating loader')

        if (isInit) return;

        loading = await loadingController
            .create({
                message: message ?? t('label.wait'),
                spinner: 'crescent',
                cssClass: 'loading-spinner custom-loading'
            });

        isInit = true;
    }

    const showLoading = async (message?: string, forceDismiss?: number): Promise<void> => {
        await createLoadingController();
        loading.message = message ?? t('label.wait')
        await loading.present()
        if (forceDismiss) setTimeout(async () => {
            if (await loadingController.getTop()) await loading.dismiss()
        }, forceDismiss)
    }

    const hideLoading = async (): Promise<void> => {
        await loadingController.dismiss(undefined, 'cancel').catch(() => {
            return
        });
        isInit = false;
    }

    return {
        showLoading,
        hideLoading,
    }

}
